import isExifRotationSupported from './is-exif-rotation-supported';
import hasExifOrientation from './has-exif-orientation';

export default {
  isExifRotationSupported,
  hasExifOrientation,
};
